import { ApolloProvider } from "@apollo/client";
import { MuiThemeProvider, StylesProvider } from "@material-ui/core/styles";
import { AppRoute } from "components/routes";
import ErrorBoundary from "components/routes/app_routes/ErrorBoundary";
import { GraphQLClient } from "config/graphqlClient";
import { theme } from "config/theme";
import { AlertProvider } from "contexts/AlertContext";
import InfoBarProvider from "contexts/InfoBarContext";
import { JobProvider } from "contexts/JobContext";
import ParcelStoreProvider from "contexts/ParcelsDataContext";
import React, { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { Loader } from "ui/Loader";

function App() {
  return (
    <ApolloProvider client={GraphQLClient}>
      <ThemeProvider theme={theme}>
        <StylesProvider injectFirst>
          <MuiThemeProvider theme={theme}>
            <JobProvider>
              <AlertProvider>
                <ErrorBoundary>
                <InfoBarProvider>
                  <ParcelStoreProvider>
                    <Suspense fallback={<Loader />}>
                      <Router>
                        <AppRoute />
                      </Router>
                    </Suspense>
                  </ParcelStoreProvider>
                  </InfoBarProvider>
                </ErrorBoundary>
              </AlertProvider>
            </JobProvider>
          </MuiThemeProvider>
        </StylesProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
}


export default App;
